import React, { useState, useEffect } from "react";
import { Grid, Card, Icon, Carousel, Divider } from "@scuf/common";
import TitlePage from "../../components/TitlePage/TitlePage";
import AllActualAPC from "../../components/Charts/APC/AllActualAPC";
import UtilizacionAPC from "../../components/Charts/APC/UtilizacionAPC";
import LineAPC from "../../components/Charts/APC/LineAPC";

import "./APC.css";

export default function APC() {
  const [stateAll, setStateAll] = useState(null);

  // All valor actual
  useEffect(() => {
    const fData = async () => {
      setStateAll(await AllActualAPC.getAll());
      setTimeout(() => {
        fData();
      }, 60000);
    };
    fData();
  }, []);

  function VarAPC(KPI) {
    try {
      const KPIValue = stateAll.filter((x) => x.KPI === KPI)[0].Valor;
      const KPIUOM = stateAll.filter((x) => x.KPI === KPI)[0].UOM;
      return KPIValue + " " + KPIUOM;
    } catch {
      return <div className="letter-origin">...</div>;
    }
  }

  const fRowCarousel = (title, KPI, body) => {
    return (
      <Grid.Row>
        <Grid.Column width={9} className="p-0">
          <div className="timeLine pt-0 pb-0 mx-2">
            <div className="letter-origin" style={{ fontSize: "9px" }}>
              {title}
            </div>
            <LineAPC body={body} height={50} name={title} color="" />
          </div>
        </Grid.Column>

        <Grid.Column width={3}>
          <div className="subtitle-VarAPC mt-4 text-start">{VarAPC(KPI)}</div>
        </Grid.Column>
      </Grid.Row>
    );
  };

  const fTostador = () => {
    return (
      <Carousel
        className="m-0 p-0"
        style={{ width: "100%", marginBottom: "100px" }}
        height={400}
      >
        <Carousel.Slide
          content={
            <Grid className="mt-0 ms-3 me-2 p-0">
              <Grid.Row>
                <Grid.Column width={9}>
                  <div className="subtitle-cardDomo text-start">variable</div>
                </Grid.Column>
                <Grid.Column width={3}>
                  <div className="subtitle-cardDomo text-start pb-0">
                    actual
                  </div>
                </Grid.Column>
              </Grid.Row>
              {fRowCarousel("TONELAJE", "Tonelaje", {
                opcion: 2,
                orden: 1,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
              {fRowCarousel("FLUJO DE AIRE", "Flujo de aire", {
                opcion: 2,
                orden: 2,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
              {fRowCarousel("PROM T° SUPERIOR", "Promedio T° superiores", {
                opcion: 2,
                orden: 3,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
              {fRowCarousel(
                "T° MÁX DEL PROM SUPERIOR",
                "T° Máxima del promedio de las superiores",
                { opcion: 2, orden: 4, ultimo: 0, frecuencia: 5, periodo: 1 }
              )}
            </Grid>
          }
        ></Carousel.Slide>
      </Carousel>
    );
  };

  const fTrenGases = () => {
    return (
      <Carousel
        className="m-0 p-0"
        style={{ width: "100%", marginBottom: "100px" }}
        autoPlay={true}
        transitionTime={10000}
        height={400}
      >
        <Carousel.Slide
          content={
            <Grid className="mt-0 ms-3 me-2 p-0">
              <Grid.Row>
                <Grid.Column width={9}>
                  <div className="subtitle-cardDomo text-start">variable</div>
                </Grid.Column>
                <Grid.Column width={3}>
                  <div className="subtitle-cardDomo text-start pb-0">
                    actual
                  </div>
                </Grid.Column>
              </Grid.Row>
              {fRowCarousel(
                "CONCEN SO2 EN CHIMENEA",
                "Concentración SO2 en Chimenea",
                { opcion: 2, orden: 10, ultimo: 0, frecuencia: 5, periodo: 1 }
              )}
              {fRowCarousel("PRESIÓN RFS", "Presión RFS", {
                opcion: 2,
                orden: 11,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
              {fRowCarousel(
                "FLUJO GASES A PLANTA ÁCIDO",
                "Flujo Gases a Planta Ácido",
                { opcion: 2, orden: 9, ultimo: 0, frecuencia: 5, periodo: 1 }
              )}
              {fRowCarousel("PRESIÓN SALIDA EDP", "Presión Salida EDP", {
                opcion: 2,
                orden: 8,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
            </Grid>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          content={
            <Grid className="mt-0 ms-3 me-2 p-0">
              <Grid.Row>
                <Grid.Column width={9}>
                  <div className="subtitle-cardDomo text-start">variable</div>
                </Grid.Column>
                <Grid.Column width={3}>
                  <div className="subtitle-cardDomo text-start pb-0">
                    actual
                  </div>
                </Grid.Column>
              </Grid.Row>
              {fRowCarousel(
                "PRESIÓN INTERNA TOSTADOR",
                "Presión Interna Tostador",
                { opcion: 2, orden: 5, ultimo: 0, frecuencia: 5, periodo: 1 }
              )}
              {fRowCarousel(
                "T° ALIMENTACIÓN ESP",
                "Temperatura Alimentación ESP",
                { opcion: 2, orden: 6, ultimo: 0, frecuencia: 5, periodo: 0 }
              )}
              {fRowCarousel(
                "VIBRACIONES VENTILADOR 01",
                "Vibraciones Ventilador 01",
                { opcion: 2, orden: 7, ultimo: 0, frecuencia: 5, periodo: 0 }
              )}
            </Grid>
          }
        ></Carousel.Slide>
      </Carousel>
    );
  };
  

  const fPlantaAcido = () => {
    return (
      <Carousel
        className="m-0 p-0"
        style={{ width: "100%", marginBottom: "100px" }}
        autoPlay={true}
        transitionTime={10000}
        height={400}
      >
        <Carousel.Slide
          content={
            <Grid className="mt-0 ms-3 me-2 p-0">
              <Grid.Row>
                <Grid.Column width={9}>
                  <div className="subtitle-cardDomo text-start">variable</div>
                </Grid.Column>
                <Grid.Column width={3}>
                  <div className="subtitle-cardDomo text-start pb-0">
                    actual
                  </div>
                </Grid.Column>
              </Grid.Row>
              {fRowCarousel("NIVEL ESTANQUE 01", "Nivel Estanque 01", {
                opcion: 2,
                orden: 12,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
              {fRowCarousel("NIVEL ESTANQUE 02", "Nivel Estanque 02", {
                opcion: 2,
                orden: 13,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
              {fRowCarousel("NIVEL ESTANQUE 03", "Nivel Estanque 03", {
                opcion: 2,
                orden: 14,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
              {fRowCarousel("T° TEF", "T° TEF", {
                opcion: 2,
                orden: 17,
                ultimo: 0,
                frecuencia: 5,
                periodo: 1,
              })}
            </Grid>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          content={
            <Grid className="mt-0 ms-3 me-2 p-0">
              <Grid.Row>
                <Grid.Column width={5}>
                  <div className="subtitle-cardDomo text-start">variable</div>
                </Grid.Column>
                <Grid.Column width={4}>
                  <div className="subtitle-cardDomo text-start">desviación</div>
                </Grid.Column>
                <Grid.Column width={3}>
                  <div className="subtitle-cardDomo text-start pb-0">
                    actual
                  </div>
                </Grid.Column>
              </Grid.Row>
              {fRowCarousel("T° ESTANQUE 2", "Temperatura Alimentación ESP", {
                opcion: 2,
                orden: 18,
                ultimo: 0,
                frecuencia: 5,
                periodo: 0,
              })}
              {fRowCarousel(
                "CONCENTRACIÓN ÁCIDO TS",
                "Concentración ácido TS (torre secado)",
                { opcion: 2, orden: 15, ultimo: 0, frecuencia: 5, periodo: 1 }
              )}
              {fRowCarousel(
                "CONCENTRACIÓN ÁCIDO TAI",
                "Concentración acido TAI (torre absorción interna)",
                { opcion: 2, orden: 16, ultimo: 0, frecuencia: 5, periodo: 1 }
              )}
            </Grid>
          }
        ></Carousel.Slide>
      </Carousel>
    );
  };

  return (
    <div className="minTopPage">
      <Grid className="m-0 p-0">
        <Grid.Row>
          <TitlePage title="APC" />
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4} sWidth={12} xsWidth={12}>
            <div className="spaceAmongDiv1">
              <Card style={{ minHeight: "310px" }}>
                <Card.Header title="TOSTADOR">
                  <Icon name="increasing" root="common" />
                </Card.Header>
                <Card.Content>
                  <Divider />
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={12} className="p-0">
                        <UtilizacionAPC
                          body={{
                            opcion: 2,
                            orden: 19,
                            ultimo: 1,
                            frecuencia: 1,
                            periodo: 1,
                          }}
                          height={165}
                          name="Utilización"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>{fTostador()}</Grid.Row>
                  </Grid>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
          <Grid.Column width={4} sWidth={12} xsWidth={12}>
            <div className="spaceAmongDiv32">
              <Card style={{ minHeight: "310px" }}>
                <Card.Header title="TREN DE GASES">
                  <Icon name="increasing" root="common" />
                </Card.Header>
                <Card.Content>
                  <Divider />
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={12} className="p-0">
                        <UtilizacionAPC
                          body={{
                            opcion: 2,
                            orden: 20,
                            ultimo: 1,
                            frecuencia: 1,
                            periodo: 1,
                          }}
                          height={165}
                          name="Utilización"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>{fTrenGases()}</Grid.Row>
                  </Grid>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
          <Grid.Column width={4} sWidth={12} xsWidth={12}>
            <div className="spaceAmongDiv3">
              <Card style={{ minHeight: "310px" }}>
                <Card.Header title="PLANTA DE ÁCIDO">
                  <Icon name="increasing" root="common" />
                </Card.Header>
                <Card.Content>
                  <Divider />
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={12} className="p-0">
                        <UtilizacionAPC
                          body={{
                            opcion: 2,
                            orden: 21,
                            ultimo: 1,
                            frecuencia: 1,
                            periodo: 1,
                          }}
                          height={165}
                          name="Utilización"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>{fPlantaAcido()}</Grid.Row>
                  </Grid>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
}
